<template>
  <div>
    <div v-for="(item, key) in items"
         :key="key"
         :class="key">
      <div class="filter"
           v-if="filter === key"
           v-show="status">
        <div class="search-text" v-if="filters >= filtersNumber" >
          <input type="text"
                 v-model="searchFilter"
                 @input="searchFilters">
          <div class="placeholder" v-if="!searchFilter">
            <span>
              <localized-label>toolbarPanelSearchFilterLabel</localized-label>
            </span>
          </div>
        </div>
        <div class="filter-text">
          <span @click="selectAllFilters()">
            <localized-label>toolbarPanelSelectAllLabel</localized-label>
          </span>
          <span @click="deselectAllFilters()">
            <localized-label>toolbarPanelClearLabel</localized-label>
          </span>
        </div>
        <div class="filter-checkbox-container"
          v-if="items[key] && items[key].length">
          <div v-for="checkbox in item"
               :key="checkbox[id]">
            <div class="filter-checkbox">
              <input type="checkbox"
                     :id="checkbox[id]"
                     :value="checkbox[id]"
                     v-model="selectedItems"
                     @input="multiSelectFilters">
              <label :for="checkbox[id]">
                <span v-if="isStatusFilter">
                  {{getStatusTranslation(checkbox.title)}}
                </span>
                <span v-else>
                  {{checkbox[title]}}
                </span>
              </label>
            </div>
          </div>
        </div>
        <div class="toolbar-filter-data pt-2 pl-2" v-else>
          <localized-label>toolbarPanelNoFilterDataLabel</localized-label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
  concat, debounce, each, camelCase, upperFirst, lowerCase,
} from 'lodash';

export default {
  name: 'MultiSelectFilter',
  props: {
    id: {
      type: String,
    },
    items: {
      type: Object,
    },
    filter: {
      type: String,
    },
    filters: {
      type: Number,
    },
    filtersNumber: {
      type: Number,
    },
    search: {
      type: String,
    },
    searchDelay: {
      type: Number,
    },
    selectDelay: {
      type: Number,
    },
    selected: {
      type: Array,
    },
    status: {
      type: Boolean,
    },
    title: {
      type: String,
    },
  },
  data() {
    return {
      searchFilter: this.search,
      selectedItems: this.selected,
    };
  },
  computed: {
    ...mapGetters([
      'translation',
    ]),
    isStatusFilter() {
      return this.filter === 'statuses';
    },
  },
  watch: {
    selected(update) {
      this.selectedItems = update;
    },
  },
  created() {
    this.multiSelectFilters = debounce(this.multiSelectFilters, this.selectDelay);
    this.searchFilters = debounce(this.searchFilters, this.searchDelay);
  },
  methods: {
    multiSelectFilters() {
      this.$emit('input', {
        filter: this.filter,
        selected: this.selectedItems,
      });
    },
    selectAllFilters() {
      each(this.items[this.filter], (item) => {
        this.selectedItems = concat(this.selectedItems, item[this.id]);
      });
      this.$emit('input', {
        filter: this.filter,
        selected: this.selectedItems,
      });
    },
    deselectAllFilters() {
      this.selectedItems = [];
      this.$emit('input', {
        filter: this.filter,
        selected: this.selectedItems,
      });
    },
    searchFilters() {
      this.$emit('search', {
        filter: this.filter,
        title: this.title,
        search: this.searchFilter,
      });
    },
    getStatusTranslation(value) {
      const ticketStatus = lowerCase(value) === 'payedout' ? 'PAID OUT' : value;
      const name = upperFirst(camelCase(ticketStatus));
      const key = `ticketStatus${name}`;
      return this.translation(key);
    },
  },
};
</script>
<style lang="scss">
@import "../style/mixins/scrollbar";
.filter {
  min-width: 250px;
  padding: 10px;
  background-color: #D3DADD;
}

.filter-text {
  font-size: 12px;
  color: $toolbarPanelBlueGrey;
  span {
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
  span {
    &:nth-child(2) {
      padding-left: 10px;
    }
  }
}

.search-text {
  position: relative;
  display: flex;
  align-items: center;
  width: 230px;
  height: 30px;
  background-color: #ffffff;
  padding-left: 10px;
  margin-bottom: 15px;
  input {
  border: 0;
  width: 100%;
  height: 100%;
    &:focus {
      outline: none;
    }
  }
  .placeholder {
    position: absolute;
    pointer-events: none;
    font-size: 12px;
    font-weight: 500;
    color: #757575;
  }
}

.filter-checkbox-container {
  margin-top: 8px;
  overflow: auto;
  max-height: 25em;
  &:hover {
    @include scrollbar(6px, 3px, #b0b8c1, #e8ecee, (1px solid #b0b8c1));
  }
}

.filter-checkbox {
  display: block;
  input {
    display: none;
    cursor: pointer;
    &:checked {
      + label:after {
        content: '';
        display: block;
        position: absolute;
        top: 10px;
        left: 5px;
        width: 5px;
        height: 10px;
        border: solid #768191;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }
    }
  }
  label {
    display: flex;
    align-items: center;
    position: relative;
    font-size: 12px;
    font-weight: 400;
    color: #768191;
    user-select: none;
    cursor: pointer;
    > span {
      margin-top: 6px;
    }
    &:before {
      content:'';
      border: 1px solid #768191;
      display: inline-block;
      position: relative;
      vertical-align: middle;
      cursor: pointer;
      margin-right: 10px;
      width: 16px;
      height: 16px;
      margin-top: 8px;
    }
  }
}
</style>
